import { createApi } from '@reduxjs/toolkit/query/react'
import { query } from 'api'
import type { Project, ProjectInfo, ProjectList } from 'types/Project'
import type { SalesNetworkResponse } from 'types/SalesNetworks'
// import type { SatisfactionForm } from './satisfactionSlice';

export interface GetListOptions {
  filterData?: any
  Sorts?:
    | {
        Member: string
        SortDirection: number
      }[]
    | null
}

const rtkApi = createApi({
  keepUnusedDataFor: 0,
  reducerPath: 'api',
  baseQuery: query(),
  tagTypes: ['Locations', 'Villes', 'UserInfo', 'ClientInfo', 'ProjectsList', 'Environnements', 'Maintenance', 'Tutorials', 'AdminTutorials', 'DataSources', 'LayoutDefs'],
  endpoints: (builder) => ({
    // getSalesNetworks: builder.query<SalesNetworksResponse, void>({
    //   query: () => ({ url: "Application/SalesNetworks", method: "GET" }),
    // }),
    getInfos: builder.query<SalesNetworkResponse, string>({
      query: (env) => ({
        url: `infos/${env}`,
        method: 'GET',
      }),
    }),
    getTranslations: builder.query<any, string>({
      query: (lang) => ({
        url: `backofficelocals/${lang}`,
        method: 'GET',
      }),
    }),
    getTutorials: builder.query<TutorialsResponse, { environnement_id: number | string; lang: string }>({
      query: ({ environnement_id, lang }) => ({
        url: `tutorials/env=${environnement_id}&lang=${lang}`,
        method: 'GET',
        params: {},
      }),
      providesTags: ['Tutorials'],
    }),
    getAdminTutorials: builder.query<TutorialsResponse, { environnement_id: number | string; lang: string }>({
      query: ({ environnement_id, lang }) => ({
        url: `admintutorials/env=${environnement_id}&lang=${lang}`,
        method: 'GET',
        params: {},
      }),
      providesTags: ['AdminTutorials'],
    }),
    getTutorialCategories: builder.query<any, { env: number | string; lang: string }>({
      query: ({ env, lang }) => ({
        url: `tutorials/categories/env=${env}&lang=${lang}`,
        method: 'GET',
      }),
    }),
    getAdminTutorialCategories: builder.query<any, { env: number | string; lang: string }>({
      query: ({ env, lang }) => ({
        url: `tutorials/admincategories/env=${env}&lang=${lang}`,
        method: 'GET',
      }),
    }),
    uploadTutorialFile: builder.mutation<any, { userId?: number | string; name: string; file: File }>({
      query: ({ userId, name, file }) => ({
        url: 'file',
        method: 'POST',
        data: {
          userId,
          name,
          file,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
    }),
    createTutorial: builder.mutation<any, { env?: number | string; environnement_id?: number | string; category_code: string; description: string; lang?: string; category?: string; videoName?: string; video?: any }>({
      query: ({ env, environnement_id, category_code, description, lang, category, videoName, video }) => {
        const data: Record<string, any> = {
          env,
          category_code,
          description,
        };
        if (environnement_id !== undefined) data.environnement_id = environnement_id;
        if (lang) data.lang = lang;
        if (category) data.category = category;
        if (videoName) data.videoName = videoName;
        if (video) data.video = video;

        return {
          url: 'tutorials',
          method: 'POST',
          data,
          isJson: true,
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: ['Tutorials'],
    }),
    createAdminTutorial: builder.mutation<any, { env?: number | string; environnement_id?: number | string; category_code: string; description: string; lang?: string; category?: string; videoName?: string; video?: any }>({
      query: ({ env, environnement_id, category_code, description, lang, category, videoName, video }) => {
        const data: Record<string, any> = {
          env,
          category_code,
          description,
        };
        if (environnement_id !== undefined) data.environnement_id = environnement_id;
        if (lang) data.lang = lang;
        if (category) data.category = category;
        if (videoName) data.videoName = videoName;
        if (video) data.video = video;

        return {
          url: 'admintutorials',
          method: 'POST',
          data,
          isJson: true,
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: ['AdminTutorials'],
    }),
    updateTutorial: builder.mutation<any, { id: number | string; env?: number | string; category_code: string; description: string; environnement_id?: number | string; lang?: string; category?: string; videoName?: string; video?: any }>({
      query: ({ id, env, category_code, description, environnement_id, lang, category, videoName, video }) => {
        const data: Record<string, any> = {
          id,
          category_code,
          description,
        };
        if (env !== undefined) data.env = env;
        if (environnement_id !== undefined) data.environnement_id = environnement_id;
        if (lang) data.lang = lang;
        if (category) data.category = category;
        if (videoName) data.videoName = videoName;
        if (video) data.video = video;

        return {
          url: `tutorials/${id}`,
          method: 'PUT',
          data,
          isJson: true,
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: ['Tutorials'],
    }),
    updateAdminTutorial: builder.mutation<any, { id: number | string; env?: number | string; category_code: string; description: string; environnement_id?: number | string; lang?: string; category?: string; videoName?: string; video?: any }>({
      query: ({ id, env, category_code, description, environnement_id, lang, category, videoName, video }) => {
        const data: Record<string, any> = {
          id,
          category_code,
          description,
        };
        if (env !== undefined) data.env = env;
        if (environnement_id !== undefined) data.environnement_id = environnement_id;
        if (lang) data.lang = lang;
        if (category) data.category = category;
        if (videoName) data.videoName = videoName;
        if (video) data.video = video;

        return {
          url: `admintutorials/${id}`,
          method: 'PUT',
          data,
          isJson: true,
          headers: {
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: ['AdminTutorials'],
    }),
    //TODO: network code
    getFAQ: builder.query<FAQResponse, null>({
      query: () => ({
        url: 'faq',
        method: 'GET',
      }),
    }),
    getVersions: builder.query<VersionsResponse, null>({
      query: () => ({
        url: 'versions',
        method: 'GET',
      }),
    }),
    getUserInfo: builder.query<UserInfo, void>({
      query: () => ({
        url: `userinfos`,
        method: 'GET',
      }),
      providesTags: ['UserInfo'],
    }),

    updateUserInfo: builder.mutation<void, any>({
      query: (userInfo) => {
        // if (systemUser.images == null)
        //   systemUser = { ...systemUser, images: [] };
        return {
          url: `userinfos`,
          method: 'PATCH',
          data: { data: userInfo },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['UserInfo'],
    }),

    updateSatisfaction: builder.mutation<void, any>({
      query: (formData) => {
        return {
          url: `satisfaction/1`,
          method: 'POST',
          data: formData,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
    }),

    getClients: builder.query<
      ClientList,
      {
        pageNumber: number | string
        pageSize: number | string
        searchInput: string
      }
    >({
      query: ({ pageNumber, pageSize, searchInput }) => ({
        url: `client?pageNumber=${pageNumber}&pageSize=${pageSize}&searchInput=${searchInput}`,
        method: 'GET',
      }),
      providesTags: ['ClientInfo'],
    }),
    createClient: builder.mutation<Client, { data: ClientInfo }>({
      query: (payload) => {
        // debugger;

        return {
          url: `client`,
          method: 'POST',
          data: payload,
          // data: { data: clientData },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'],
    }),

    updateClient: builder.mutation<void, { id?: number; data: ClientInfo }>({
      query: (payload) => {
        // debugger;

        return {
          url: `client/${payload.id}`,
          method: 'PATCH',
          data: payload,
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'], // Adjust tags as needed
    }),

    deleteClient: builder.mutation<void, number>({
      query: (id) => {
        return {
          url: `client/${id}`,
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ClientInfo'], // Adjust tags as needed
    }),
    // getLocations: builder.query<GetLocationsResponse, void>({
    //   query: () => ({
    //     url: `Moteur/GetLocations`,
    //     method: "GET",
    //   }),
    //   transformResponse: (res: GetLocationsResponse) => {
    //     return res.map((i) => ({ text: i.text, value: i.text }));
    //   },
    //   providesTags: () => [{ type: "Locations" }],
    // }),
    // getLocationInfo: builder.query<
    //   GetLocationInfoResponse,
    //   { code: string; altitude?: number; bord_de_mer_montagne?: boolean }
    // >({
    //   query: ({ code, altitude, bord_de_mer_montagne }) => ({
    //     url: `Moteur/GetLocationInfo`,
    //     method: "GET",
    //     params: { code_ville: code, altitude, bord_de_mer_montagne },
    //   }),
    // }),
    // getVilles: builder.query<GetVillesResponse, { networkCode: string }>({
    //   query: ({ networkCode }) => ({
    //     url: `Moteur/GetVilles`,
    //     method: "GET",
    //     params: { code_commercial: networkCode },
    //   }),
    //   transformResponse: (res: GetVillesResponse) => {
    //     return res.map((i) => ({ ...i, text: i.text, value: i.text }));
    //   },
    //   providesTags: () => [{ type: "Villes" }],
    // }),
    // getSolutionElectric: builder.query<GetSolutionResponse, GetSolutionRequest>(
    //   {
    //     query: (data) => ({
    //       url: `Moteur/SolutionElectric`,
    //       method: "POST",
    //       data,
    //       isJson: true,
    //     }),
    //   }
    // ),
    // getSolutionHybride: builder.query<GetSolutionResponse, GetSolutionRequest>({
    //   query: (data) => ({
    //     url: `Moteur/SolutionHybride`,
    //     method: "POST",
    //     data,
    //     isJson: true,
    //   }),
    // }),
    // getEtude: builder.query<GetEtudeResponse, { id: number; code?: string }>({
    //   query: ({ id, code }) => ({
    //     url: `Etude/GetData`,
    //     method: "GET",
    //     params: { id: id, code: code },
    //     //isJson: true,
    //   }),
    // }),
    getProjectsList: builder.query<
      ProjectList,
      { code?: string | undefined; pageSize?: number; pageNumber?: number; searchInput?: string; stepIndexes?: number[] }
    >({
      query: ({ code, pageSize, pageNumber, searchInput, stepIndexes }) => ({
        url: `projects/${code}`,
        method: 'GET',
        params: { pageSize: pageSize, pageNumber: pageNumber, searchInput: searchInput, stepIndexes },
        //isJson: true,
      }),
      providesTags: ['ProjectsList'],
    }),
    updateDublicateProject: builder.mutation<void, { project?: Project }>({
      query: ({ project }) => ({
        url: `duplicateProject/${project?.id}`,
        method: 'GET',
        //isJson: true,
      }),
      invalidatesTags: ['ProjectsList'],
    }),
    loadProject: builder.query<ProjectInfo, { id: string; uid?: string }>({
      query: ({ id, uid }) => ({
        url: `project/${id}` + (uid ? `/${uid}` : ''),
        method: 'GET',
        //isJson: true,
      }),
    }),
    createProject: builder.mutation<ProjectInfo, ProjectInfo>({
      query: (project) => {
        // debugger;

        return {
          url: `project`,
          method: 'POST',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      invalidatesTags: ['ProjectsList'],
    }),

    updateProject: builder.mutation<void, ProjectInfo>({
      query: (project) => {
        // debugger;

        return {
          url: `project/${project.id}`,
          method: 'PATCH',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      invalidatesTags: ['ProjectsList'], // Adjust tags as needed
    }),
    deleteProject: builder.mutation<void, { project?: Project; includeVersions?: boolean }>({
      query: ({ project, includeVersions }) => {
        return {
          url: `project/${project?.id}` + (includeVersions ? '?includeVersions=true' : ''),
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['ProjectsList'],
    }),
    getParamenters: builder.query<Parameter[], { env?: number }>({
      query: ({ env }) => ({
        url: `parameters/env=${env}`,
        method: 'GET',
      }),
    }),
    getDepartments: builder.query<ValueListItem[], { env?: string }>({
      query: ({ env }) => ({
        url: `departments/${env}`,
        method: 'GET',
        //isJson: true,
      }),
    }),
    getStations: builder.query<ValueListItem[], { env?: string; department?: string }>({
      query: ({ env, department }) => ({
        url: `stations/${env}/${department}`,
        method: 'GET',
        //isJson: true,
      }),
    }),
    getTbase: builder.query<number, { env?: string; department: string; altitude: number; seaside: boolean }>({
      query: ({ env, department, altitude, seaside }) => {
        return {
          url: `tbase/${env}/${department}/${altitude}/${seaside}`,
          method: 'GET',
        }
      },
    }),
    getVAT: builder.query<any[], { env?: string }>({
      query: ({ env }) => {
        return {
          url: `vatByEnv/${env}`,
          method: 'GET',
        }
      },
    }),

    getLoss: builder.mutation<any, { env: string; project: any }>({
      query: ({ env, project }) => {
        // debugger;
        return {
          url: `loss/${env}`,
          method: 'POST',
          data: { project },
          // data: { data: clientData },
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
      // invalidatesTags: ["ClientInfo"],
    }),
    getResults: builder.query<any, { env?: string; project: any }>({
      query: ({ env, project }) => ({
        url: `results/${env}`,
        data: { project },
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    getAccessories: builder.query<any[], { env?: string; productCode: string }>({
      query: ({ env, productCode }) => ({
        url: `accessories/${env}/${productCode}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    getDocuments: builder.query<any[], { env?: string; productId: string }>({
      query: ({ env, productId }) => ({
        url: `documents/${env}/${productId}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        isJson: true,
      }),
    }),
    generateXlsx: builder.mutation<Blob, { data?: any }>({
      query: ({ data }) => {
        // debugger;
        return {
          url: `generateXlsx`, //UpdateFormDataJson
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
          responseType: 'blob',
        }
      },
    }),
    generatePdf: builder.mutation<Blob, { data?: any }>({
      query: ({ data }) => {
        // debugger;
        return {
          url: `generatePdf`, //UpdateFormDataJson
          method: 'POST',
          data: data,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
          responseType: 'blob',
        }
      },
    }),
    uploadUserLogo: builder.mutation<void, { userId?: number; name: string; file: any }>({
      query: ({ userId, name, file }) => {
        return {
          url: `file`,
          method: 'POST',
          data: { userId, name, file },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      },
    }),
    changeUserLogo: builder.mutation<void, { userId?: number; name: string; file: any; imageId: number }>({
      query: ({ userId, name, file, imageId }) => {
        return {
          url: `file/${imageId}`,
          method: 'PUT',
          data: { userId, name, file },
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      },
    }),
    deleteUserLogo: builder.mutation<void, {}>({
      query: ({}) => {
        return {
          url: `userinfos/logo`,
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      },
      invalidatesTags: ['UserInfo'],
    }),

    createProjectTrace: builder.mutation<any, { env?: number, project: any}>({
      query: ({env, project}) => {
        return {
          url: `projectTrace/${env}`,
          method: 'POST',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
    }),

    updateProjectTrace: builder.mutation<any, { traceId?: any, project: any}>({
      query: ({traceId, project}) => {
        return {
          url: `projectTrace/${traceId}`,
          method: 'PATCH',
          data: project,
          headers: {
            'Content-Type': 'application/json',
          },
          isJson: true,
        }
      },
    }),

    getEnvironnements: builder.query<any, string>({
      query: () => ({
        url: `environnement`,
        method: 'GET',
      }),
      providesTags: ['Environnements'],
    }),

    getAdminUsers: builder.query<any, string>({
      query: () => ({
        url: `adminuser`,
        method: 'GET',
      }),
    }),

    getStandardUsers: builder.query<any, string>({
      query: () => ({
        url: `standardusers`,
        method: 'GET',
      }),
    }),

    getMenu: builder.query<any, string>({
      query: () => ({
        url: `menudefs`,
        method: 'GET',
      }),
    }),
    getLayoutDef: builder.query<any, string | number>({
      query: (id) => ({
        url: `layoutdefs/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'LayoutDefs', id: String(id) }],
    }),
    updateLayoutDef: builder.mutation<any, { id: string | number; layout: any[] }>({
      query: ({ id, layout }) => ({
        url: `layoutdefs/${id}`,
        method: 'PATCH',
        data: { layout },
        isJson: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'LayoutDefs', id: String(id) }],
    }),
    getDataSources: builder.query<any[], string>({
      query: () => ({
        url: `dataSources`,
        method: 'GET',
      }),
      providesTags: ['DataSources'],
    }),
    createDataSource: builder.mutation<any, Record<string, unknown>>({
      query: (data) => ({
        url: `dataSources`,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['DataSources'],
    }),
    updateDataSource: builder.mutation<any, { id: string | number; data: Record<string, unknown> }>({
      query: ({ id, data }) => ({
        url: `dataSources/${id}`,
        method: 'PATCH',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['DataSources'],
    }),
    deleteDataSource: builder.mutation<any, { id: string | number }>({
      query: ({ id }) => ({
        url: `dataSources/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DataSources'],
    }),
    getMaintenanceStatus: builder.query<{ isInMaintenance?: boolean }, void>({
      query: () => ({
        url: 'maintenance/get',
        method: 'GET',
      }),
      providesTags: ['Maintenance'],
    }),
    setMaintenanceStatus: builder.mutation<void, { isMaint: boolean; dateStart?: string; dateEnd?: string }>({
      query: ({ isMaint, dateStart, dateEnd }) => ({
        url: 'maintenance/set',
        method: 'POST',
        data: {
          isMaint,
          dateStart: dateStart ?? '',
          dateEnd: dateEnd ?? '',
        },
        isJson: true,
      }),
      invalidatesTags: ['Maintenance'],
    }),
    /** layoutId / datasourceId are cache-key only (not sent); avoids stale rows when URLs match. */
    readDatasource: builder.query<
      any,
      {
        url: string
        method?: string
        params?: any
        data?: any
        baseUrl?: string
        layoutId?: string | number
        datasourceId?: number
      }
    >({
      query: ({ url, method = 'GET', params, data, baseUrl }) => ({
        url,
        method: method as any,
        params,
        data,
        ...(baseUrl ? { baseUrl } : {}),
      }),
    }),
    addLayout: builder.mutation<any, { menuId: string | number; layoutId: string | number }>({
      query: ({ menuId, layoutId }) => ({
        url: `menudefs/${menuId}`,
        method: 'PATCH',
        data: { layoutId },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    createMenuDef: builder.mutation<any, {
      name: string;
      icon?: string;
      parent?: number;
      layoutId?: number;
      extUrl?: string;
      superAdmin?: boolean;
      title?: boolean;
    }>({
      query: (data) => ({
        url: 'menudefs',
        method: 'POST',
        data,
        isJson: true,
      }),
    }),
    updateMenuDef: builder.mutation<any, {
      id: string | number;
      data: {
        name: string;
        icon?: string;
        parent?: number;
        layoutId?: number;
        extUrl?: string;
        superAdmin?: boolean;
        title?: boolean;
      };
    }>({
      query: ({ id, data }) => ({
        url: `menudefs/${id}`,
        method: 'PATCH',
        data,
        isJson: true,
      }),
    }),

    createVat: builder.mutation<any, { url: string; method: string; rate: number; env: number }>({
      query: ({ url, method, rate, env }) => ({
        url,
        method: method as any,
        data: { rate, env },
        isJson: true,
      }),
    }),

    updateVat: builder.mutation<any, { url: string; method: string; data: any }>({
      query: ({ url, method, data }) => ({
        url,
        method: method as any,
        data,
        isJson: true,
      }),
    }),

    updateEnergy: builder.mutation<any, { url: string; method: string; data: any }>({
      query: ({ url, method, data }) => ({
        url,
        method: method as any,
        data,
        isJson: true,
      }),
    }),

    createEnergy: builder.mutation<any, { url: string; method: string; data: any }>({
      query: ({ url, method, data }) => ({
        url,
        method: method as any,
        data,
        isJson: true,
      }),
    }),

    createLocale: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateLocale: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createEnvironment: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
      invalidatesTags: ['Environnements'],
    }),

    updateEnvironment: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PATCH",
        data,
        isJson: true,
      }),
      invalidatesTags: ['Environnements'],
    }),

    createAdminUser: builder.mutation<any, { uid: number | string; entities: Array<number | string> }>({
      query: ({ uid, entities }) => ({
        url: "adminuser",
        method: "POST",
        data: { uid, entities },
        isJson: true,
      }),
    }),

    updateAdminUser: builder.mutation<any, { id: number | string; data: { entities: Array<number | string> } }>({
      query: ({ id, data }) => ({
        url: `adminuser/${id}`,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createAccessoryGroup: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateAccessoryGroup: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    updateYearLoss: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createAnnex: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateAnnex: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createParameter: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateParameter: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createFaq: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateFaq: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createVersion: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateVersion: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createDiscountManagement: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    createAccessory: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateAccessory: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    updateHeatpump: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    createHeatpump: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    createHeatpumpDoc: builder.mutation<any, { heatpumpId: string | number; data: any }>({
      query: ({ heatpumpId, data }) => ({
        url: `admin/heatpumps/docs/${heatpumpId}`,
        method: "POST",
        data,
        isJson: true,
      }),
    }),

    updateHeatpumpDoc: builder.mutation<any, { id: string | number; data: any }>({
      query: ({ id, data }) => ({
        url: `admin/heatpumps/docs/${id}`,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

    deleteHeatpumpDoc: builder.mutation<any, { id: string | number }>({
      query: ({ id }) => ({
        url: `admin/heatpumps/docs/${id}`,
        method: "DELETE",
      }),
    }),

    getAllAccessories: builder.query<any[], void>({
      query: () => ({
        url: "accessories/all",
        method: "GET",
      }),
    }),

    getAccessoryGroups: builder.query<any[], string>({
      query: (lang) => ({
        url: `accessorygroup/lang=${lang}`,
        method: "GET",
      }),
    }),

    getAccessoryDepInc: builder.query<any, { code: string; env: string | number }>({
      query: ({ code, env }) => ({
        url: `accessories/depinc/code=${code}&env=${env}`,
        method: "GET",
      }),
    }),

    updateDiscountManagement: builder.mutation<any, { url: string; data: any }>({
      query: ({ url, data }) => ({
        url,
        method: "PUT",
        data,
        isJson: true,
      }),
    }),

  }),
})

export const {
  useGetTranslationsQuery,
  useGetTutorialsQuery,
  useGetAdminTutorialsQuery,
  useLazyGetTutorialCategoriesQuery,
  useLazyGetAdminTutorialCategoriesQuery,
  useUploadTutorialFileMutation,
  useCreateTutorialMutation,
  useCreateAdminTutorialMutation,
  useUpdateTutorialMutation,
  useUpdateAdminTutorialMutation,
  useGetFAQQuery,
  useGetVersionsQuery,
  useGetInfosQuery,
  useGetUserInfoQuery,
  useLazyGetUserInfoQuery,
  useUpdateUserInfoMutation,
  useUpdateSatisfactionMutation,
  useGetClientsQuery,
  ////////
  useCreateClientMutation,
  useUpdateClientMutation,
  useDeleteClientMutation,
  ///////
  useGetProjectsListQuery,
  useUpdateDublicateProjectMutation,
  useLazyLoadProjectQuery,
  useCreateProjectMutation,
  useUpdateProjectMutation,
  useDeleteProjectMutation,
  useLazyGetDepartmentsQuery,
  useLazyGetStationsQuery,
  useGetTbaseQuery,
  useLazyGetTbaseQuery,
  useGetLossMutation,
  //useGetResultsQuery,
  useLazyGetResultsQuery,
  useLazyGetAccessoriesQuery,
  //useGetDocumentsQuery,
  useLazyGetDocumentsQuery,
  useUploadUserLogoMutation,
  useChangeUserLogoMutation,
  useDeleteUserLogoMutation,
  useLazyGetVATQuery,
  useGenerateXlsxMutation,
  useGeneratePdfMutation,
  useGetParamentersQuery,
  useLazyGetParamentersQuery,
  //
  useCreateProjectTraceMutation,
  useUpdateProjectTraceMutation,


  useGetEnvironnementsQuery,
  useGetAdminUsersQuery,
  useGetStandardUsersQuery,
  useGetMenuQuery,
  useGetLayoutDefQuery,
  useUpdateLayoutDefMutation,
  useGetDataSourcesQuery,
  useCreateDataSourceMutation,
  useUpdateDataSourceMutation,
  useDeleteDataSourceMutation,
  useLazyGetMaintenanceStatusQuery,
  useSetMaintenanceStatusMutation,
  useReadDatasourceQuery,
  useAddLayoutMutation,
  useCreateMenuDefMutation,
  useUpdateMenuDefMutation,
  useCreateVatMutation,
  useUpdateVatMutation,
  useUpdateEnergyMutation,
  useCreateEnergyMutation,
  useCreateLocaleMutation,
  useUpdateLocaleMutation,
  useCreateEnvironmentMutation,
  useUpdateEnvironmentMutation,
  useCreateAdminUserMutation,
  useUpdateAdminUserMutation,
  useCreateAccessoryGroupMutation,
  useUpdateAccessoryGroupMutation,
  useUpdateYearLossMutation,
  useCreateAnnexMutation,
  useUpdateAnnexMutation,
  useCreateParameterMutation,
  useUpdateParameterMutation,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useCreateVersionMutation,
  useUpdateVersionMutation,
  useCreateDiscountManagementMutation,
  useUpdateDiscountManagementMutation,
  useCreateAccessoryMutation,
  useUpdateAccessoryMutation,
  useCreateHeatpumpMutation,
  useUpdateHeatpumpMutation,
  useCreateHeatpumpDocMutation,
  useUpdateHeatpumpDocMutation,
  useDeleteHeatpumpDocMutation,
  useLazyGetAllAccessoriesQuery,
  useLazyGetAccessoryGroupsQuery,
  useLazyGetAccessoryDepIncQuery,
} = rtkApi

export default rtkApi
